import { signInWithRedirect } from 'aws-amplify/auth';

import { postSignInRedirectStorageKey } from '@constants/auth.constant';

const retryKey = 'google-signin-retry';
const linkRacePattern = /already found an entry for username/i;
const defaultPostSignInRedirect = '/tasks';

type ResolvePostSignInRedirectInput = {
  origin?: string;
  redirect?: string | null;
};

export function resolvePostSignInRedirect({
  origin = globalThis.location.origin,
  redirect,
}: ResolvePostSignInRedirectInput): string {
  if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
    return defaultPostSignInRedirect;
  }

  try {
    const url = new URL(redirect, origin);

    if (url.origin !== origin) {
      return defaultPostSignInRedirect;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return defaultPostSignInRedirect;
  }
}

export function startGoogleSignIn(redirect?: string): void {
  const redirectTarget = resolvePostSignInRedirect({ redirect });

  sessionStorage.removeItem(retryKey);

  if (redirectTarget === defaultPostSignInRedirect) {
    sessionStorage.removeItem(postSignInRedirectStorageKey);
  } else {
    sessionStorage.setItem(postSignInRedirectStorageKey, redirectTarget);
  }

  signInWithRedirect({ provider: 'Google' });
}

export async function retrySignInAfterLinking(error: string): Promise<boolean> {
  if (!linkRacePattern.test(error) || sessionStorage.getItem(retryKey)) {
    return false;
  }

  sessionStorage.setItem(retryKey, '1');

  try {
    await signInWithRedirect({ provider: 'Google' });
    return true;
  } catch {
    sessionStorage.removeItem(retryKey);
    return false;
  }
}
